import React, { useEffect, useState } from 'react';
import { View, Text, FlatList, TouchableOpacity, ActivityIndicator, Linking, Image, StyleSheet } from 'react-native';
import { get, post, mediaUrl } from '../../api/client';
import { useSession } from '../../context/SessionContext';

export default function DealsScreen({ route }: any) {
  const competitionId: number = route.params.competitionId;
  const [items, setItems] = useState<any[] | null>(null);
  const [loading, setLoading] = useState(true);
  const session = useSession();

  useEffect(() => {
    get<any[]>(`/competitions/${competitionId}/deals`)
      .then(res => setItems(res))
      .catch(e => console.warn(e))
      .finally(() => setLoading(false));
  }, [competitionId]);

  useEffect(() => {
    if (!items || items.length === 0) return;
    const sid = session.getSessionId(competitionId);
    items.forEach(it => {
      post<any>(`/deals/${it.id}/impression`, undefined, sid).catch((e: any) => console.warn('impression failed', e.message));
    });
  }, [items]);

  if (loading) return <View style={styles.center}><ActivityIndicator /></View>;
  if (!items || items.length === 0) {
    return (
      <View style={[styles.center, { backgroundColor: '#f0efe9' }]}>
        <Text style={{ color: '#888', fontSize: 15 }}>Ingen sponsortilbud akkurat nå.</Text>
      </View>
    );
  }

  const onClick = async (deal: any) => {
    try {
      const sid = session.getSessionId(competitionId);
      const res = await post<any>(`/deals/${deal.id}/click`, undefined, sid);
      const url = res?.landing_url ?? deal.landing_url;
      if (url) Linking.openURL(url);
    } catch (e: any) { console.warn('click failed', e.message); }
  };

  return (
    <FlatList
      style={styles.bg}
      data={items}
      keyExtractor={i => String(i.id)}
      contentContainerStyle={{ padding: 12, gap: 12 }}
      renderItem={({ item }) => (
        <View style={styles.card}>
          {item.image_url ? (
            <Image
              source={{ uri: mediaUrl(item.image_url) }}
              style={styles.image}
              resizeMode="cover"
            />
          ) : null}
          <View style={styles.cardBody}>
            <Text style={styles.sponsor}>{item.sponsor_name?.toUpperCase()}</Text>
            <Text style={styles.headline}>{item.headline}</Text>
            {item.body_text ? <Text style={styles.bodyText}>{item.body_text}</Text> : null}
            {item.promo_code ? (
              <View style={styles.promoRow}>
                <Text style={styles.promoLabel}>Kode: </Text>
                <Text style={styles.promoCode}>{item.promo_code}</Text>
              </View>
            ) : null}
            <TouchableOpacity style={styles.cta} onPress={() => onClick(item)}>
              <Text style={styles.ctaText}>Bestill {item.sponsor_name}-deal</Text>
            </TouchableOpacity>
          </View>
        </View>
      )}
    />
  );
}

const styles = StyleSheet.create({
  bg: { flex: 1, backgroundColor: '#f0efe9' },
  center: { flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#f0efe9' },
  card: {
    backgroundColor: '#fffde7',
    borderRadius: 12,
    overflow: 'hidden',
    shadowColor: '#000', shadowOpacity: 0.07, shadowRadius: 6, shadowOffset: { width: 0, height: 3 },
    elevation: 3,
  },
  image: { width: '100%', height: 160 },
  cardBody: { padding: 16 },
  sponsor: { fontSize: 11, fontWeight: '700', color: '#b8860b', letterSpacing: 0.9 },
  headline: { fontSize: 18, fontWeight: '700', color: '#1a1a1a', marginTop: 3 },
  bodyText: { fontSize: 14, color: '#555', marginTop: 6, lineHeight: 20 },
  promoRow: { flexDirection: 'row', marginTop: 8, alignItems: 'center' },
  promoLabel: { fontSize: 13, color: '#888' },
  promoCode: { fontSize: 14, fontWeight: '700', color: '#1a1a1a', letterSpacing: 1 },
  cta: {
    marginTop: 14, backgroundColor: '#c9831a',
    borderRadius: 9, paddingVertical: 13, alignItems: 'center',
  },
  ctaText: { color: '#fff', fontWeight: '700', fontSize: 15 },
});
